"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCampaignsById = exports.createFetchCampaignsById = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _get = _interopRequireDefault(require("transmute/get"));

var _formatReferences = require("reference-resolvers/lib/formatReferences");

var URL = 'campaigns/v1/campaigns/guids';

var createFetchCampaignsById = function createFetchCampaignsById(_ref) {
  var httpClient = _ref.httpClient;
  return function (ids) {
    return httpClient.get(URL, {
      query: {
        guid: ids,
        includeDeletes: true
      }
    }).then((0, _formatReferences.formatToReferencesList)({
      getId: (0, _get.default)('guid'),
      getLabel: (0, _get.default)('display_name')
    }));
  };
};

exports.createFetchCampaignsById = createFetchCampaignsById;
var fetchCampaignsById = createFetchCampaignsById({
  httpClient: _apiClient.default
});
exports.fetchCampaignsById = fetchCampaignsById;